define('view/module/cart/CartBookingDetailsTotalView',['require','lib/view/LayoutView','view/controller/booking/details/BookingLeaveConfirmationView','lib/view/ModalRegion','lib/Utils','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var BookingLeaveConfirmationView = require('view/controller/booking/details/BookingLeaveConfirmationView');
    var ModalRegion = require('lib/view/ModalRegion');
    
    var Utils = require('lib/Utils');
    var Config = require('Config');
    

    return LayoutView.extend({

        template: '#cart_module_booking_details_total_view',
    
        modelEvents: {
            'sync': 'render',
            'change': 'render',
        },

        ui: {
            'confirmLink': '.sb-confirm-leave a'
        },
        events: {
            'click @ui.confirmLink': 'confirmLinkClick'
        },

        initialize: function() {
            LayoutView.prototype.initialize.apply(this, arguments);
            
            this._bookingModel = this.getOption('bookingModel');
            this.listenTo(this._bookingModel, 'change', this.safeRender);
        },

        safeRender: function() {
            if (!this.destroyed) {
                this.render();
            }
        },

        serializeData: function () {
            var currentTax = 0, currentPretotal = 0, currentTotal = 0, currentCurrency = null;

            var prices = this._bookingModel.getPrices();
            if (prices.totals) {
                currentTax = this.getCurrentTax(prices.totals.taxes);
                currentTotal = prices.totals.total;
                currentPretotal = currentTotal - currentTax;
                currentCurrency = prices.totals.currency;
            }

            var serviceIds = [this._bookingModel.get('service_id')].concat(this.model.getServiceIds());
            if (serviceIds) {
                serviceIds = _.uniq(serviceIds);
            }
            var productIds = (this._bookingModel.get('products').map(function(p) {return p.id})).concat(this.model.getProductIds());
            if (productIds) {
                productIds = _.uniq(productIds);
            }

            var result = _.extend(LayoutView.prototype.serializeData.call(this), {
                // qty: this.model.getQty(),
                pretotal: this.getPreTotal() + currentPretotal,
                total: this.getTotal() + currentTotal,
                tax: this.model.getTax() + currentTax,
                currency: this.model.getCurrency() || currentCurrency,
                serviceIds: serviceIds.join(','),
                productIds: productIds.join(',')
            });
            return result;
        },

        getTax: function () {
            return this.model.getTax();
        },

        getCurrency: function () {
            return this.model.getCurrency();
        },

        getPreTotal:  function () {
            if (Config.getInstance().getOption('price_includes_tax')) {
                return this.model.getTotal() - this.model.getTax();
            } else {
                return this.model.getTotal();
            }
        },

        getTotal:  function () {
            if (Config.getInstance().getOption('price_includes_tax')) {
                return this.model.getTotal();
            } else {
                return this.model.getTotal() + this.model.getTax();
            }
        },

        getCurrentTax: function (taxes) {
            if (!taxes || !taxes.length) return 0;

            return taxes.reduce(function (memo, tax) {
                return memo + tax.amount;
            }, 0);
        },

        confirmLinkClick: function (evt) {
            evt.preventDefault();
            
            var $target = $(evt.currentTarget);
            var link = $target.attr('href');
            
            var region = new ModalRegion();
            var view = new BookingLeaveConfirmationView();
            region.show(view);

            this.listenTo(view, 'confirm', function () {
                window.location = link;
            });
        }

    });

});
